<template>
  <div class="thumbnail-preview-item">
    <div>
      <p class="text-center" v-if="dropzoneTitle">{{ dropzoneTitle }}</p>
      <iframe v-if="isPdf" :src="imageSrc" width="100%" height="100%" frameborder="0"></iframe>
      <img v-else :src="imageSrc" />
    </div>
    <footer v-if="!readOnly">
      <a v-if="isPdf" target="_blank" :href="imageSrc">
        <BaseButton class="thumbnail-preview-item__crop" variant="outline-secondary" v-if="isPdf">
          <BaseIcon>
            <IconPreview></IconPreview>
          </BaseIcon>
        </BaseButton>
      </a>
      <BaseButton
        class="thumbnail-preview-item__crop"
        variant="outline-secondary"
        @click="$emit('edit')"
        v-else
      >
        <BIconCrop></BIconCrop>
      </BaseButton>
      <ButtonRemove variant="outline-secondary" @click="$emit('remove-click')"></ButtonRemove>
      <ButtonDownload @click="$emit('download')" v-if="role === 'admin'"></ButtonDownload>
    </footer>
    <footer v-else>
      <template v-if="role === 'merchant'">
        <a v-if="isPdf" target="_blank" :href="imageSrc">
          <BaseButton class="thumbnail-preview-item__crop" variant="outline-secondary" v-if="isPdf">
            <BaseIcon>
              <IconPreview></IconPreview>
            </BaseIcon>
          </BaseButton>
        </a>
      </template>
      <template v-else>
        <ButtonDownload @click="$emit('download')"></ButtonDownload>
      </template>
    </footer>
  </div>
</template>

<script>
import { BIconCrop } from 'bootstrap-vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseIcon from '@/components/BaseIcon.vue';
import IconPreview from '@/components/icon/IconPreview.vue';
import imagePath from '@/filters/image-path';
import ButtonRemove from '../button/ButtonRemove.vue';
import ButtonDownload from '../button/ButtonDownload.vue';

export default {
  components: {
    BaseButton,
    BaseIcon,
    BIconCrop,
    ButtonRemove,
    IconPreview,
    ButtonDownload,
  },
  filters: {
    imagePath,
  },
  props: {
    imageSrc: {
      type: String,
    },
    readOnly: {
      type: Boolean,
    },
    uploadType: {
      type: String,
    },
    role: {
      type: String,
    },
    dropzoneTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    isPdf() {
      return this.imageSrc?.includes('.pdf');
    },
  },
};
</script>

<style lang="scss" scoped>
.thumbnail-preview-item {
  box-shadow: 1px 1px 5px 0 #a2958a;
  padding: 6px;
  margin: 8px;
  transition: box-shadow 0.15s ease-in-out;

  &:hover {
    box-shadow: 3px 3px 5px 0 #333;
  }

  & footer {
    display: flex;
    margin-top: 6px;
    justify-content: space-between;
  }

  &__crop {
    & svg {
      margin: auto !important;
    }
  }

  & img {
    width: 100px;
  }

  ::v-deep {
    & button {
      text-align: center;
      width: 30px;
      height: 30px;
      line-height: 30px;
      padding: 0;
      font-size: 90%;
      border-radius: 0.2rem;
      margin: 0;

      svg {
        margin-left: 6px;
      }
    }
  }
}
</style>
